import type { FC } from 'react';
import AssignmentForm from '@/components/AssignmentForm';
import PageContainer from '@ui/PageContainer';
import PageTitle from '@ui/PageTitle';
import useAddAssignmentPage from './useAddAssignmentPage';

const AddAssignmentPage: FC = () => {
	const state = useAddAssignmentPage();

	return (
		<PageContainer>
			<PageTitle>App assignment</PageTitle>
			<AssignmentForm state={state} />
		</PageContainer>
	);
};

export default AddAssignmentPage;
